const components = {
  appframe: {
    header: {
      logout: 'Se déconnecter',
      languages: {
        fr: 'FR',
        us: 'US',
      },
      campaign: 'Campagne actuelle',
    },
    navbar: {
      list: 'Liste',
      create: 'Créer',
      users: 'Utilisateurs',
      home: 'Accueil',
      settings: 'Administration',
      campaign: 'Campagnes',
      workshop: 'Ateliers',
      gestion: 'Gestion',
      student: 'Apprenants',
      volunteer: 'Bénévoles',
      positionedWorkshop: 'Ateliers Prévus',
      subject: 'Sujet de Cours',
      matching: 'Matching',
      timeline: 'Planning',
      site: 'Etablissement',
    },
  },
  table: {
    actions: 'Actions',
    editTooltip: 'Modifier',
    deleteTooltip: 'Supprimer',
  },
  helpButton: {
    buttonTooltip: "Plus d'infos",
    closeButtonLabel: 'Close',
  },
  confirmDialog: {
    title: 'Êtes-vous sûrs de vouloir faire ceci ?',
    close: 'Annuler',
    confirm: 'Confirmer',
  },
  availabilities: {
    title: 'Disponibilités',
    labels: {
      day: 'Jour',
      start_hour: 'Heure de début',
      end_hour: 'Heure de fin',
    },
    table: {
      add: 'Ajouter Disponibilité',
      edit: 'Modifier Disponibilité',
      no_data: 'Aucune Disponibilité',
      dialogTitle: 'Ajouter une Disponibilité',
    },
  },
  subjects: {
    title: 'Matières proposées',
    labels: {
      name: 'Nom',
      type: 'Type',
      level: 'Niveau',
    },
    table: {
      add: 'Ajouter Matière',
      edit: 'Modifier Matière',
      no_data: 'Aucune Matière',
      dialogTitle: 'Ajouter une matière',
    },
  },
  selectFilter: {
    all: 'Tous',
  },
};

export { components };
